'use client'

import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'

import { LocationCollectionSectionProps, LocationCollectionSectionView } from './LocationCollectionSectionView'

export const LocationCollectionSection = (props: LocationCollectionSectionProps) => {
  return (
    <ErrorBoundary
      fallbackRender={() => {
        return null
      }}>
      <LocationCollectionSectionView {...props} />
    </ErrorBoundary>
  )
}
